import React, { useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const NewHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language } = useLanguage();
  const sl = language === 'sl';

  const navLinks = sl ? [
    { label: 'Storitve', href: '#services' },
    { label: 'Kako deluje', href: '#process' },
    { label: 'Najem pisarn', href: '#office' },
    { label: 'Vprašanja', href: '#faq' },
    { label: 'Za investitorje', href: '/investors', isRoute: true },
    { label: 'Kontakt', href: '#contact' },
  ] : [
    { label: 'Services', href: '#services' },
    { label: 'How it works', href: '#process' },
    { label: 'Office rental', href: '#office' },
    { label: 'FAQ', href: '#faq' },
    { label: 'For Investors', href: '/investors', isRoute: true },
    { label: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-[#0E1114] text-[#F4EFE6] border-b border-[#23282E]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px]">
        <nav className="h-24 flex items-center justify-between" data-testid="header-nav" aria-label={sl ? 'Glavna navigacija' : 'Main navigation'}>
          {/* Logo */}
          <Link to={sl ? '/' : '/en'} className="flex items-center" data-testid="logo-link">
            <img 
              src="/images/logo-white.png" 
              alt="GENERAL LEDGER d.o.o. — Računovodski servis Rogatec, Slovenija" 
              className="h-[60px] w-auto"
              width="180"
              height="60"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden xl:flex items-center gap-10">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-[#C9A462] text-[15px] font-semibold no-underline hover:text-[#B8944F] transition-colors"
                  data-testid="nav-investors-link"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-[#D8D2C6] text-[15px] no-underline hover:text-white transition-colors"
                >
                  {link.label}
                </a>
              )
            ))}
            <a
              href="#offer"
              onClick={(e) => scrollToSection(e, '#offer')}
              className="flex items-center gap-2.5 bg-[#C9A462] text-[#0E1114] font-bold text-[15px] px-6 py-3.5 no-underline hover:bg-[#B8944F] transition-colors"
              data-testid="header-cta"
            >
              {sl ? 'Brezplačen posvet' : 'Free consultation'}
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="xl:hidden text-[#F4EFE6] p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden pb-6 space-y-1 border-t border-[#23282E]">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block py-4 text-[#C9A462] text-[16px] font-semibold no-underline hover:text-[#B8944F] border-b border-[#23282E]"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="block py-4 text-[#D8D2C6] text-[16px] no-underline hover:text-white border-b border-[#23282E]"
                >
                  {link.label}
                </a>
              )
            ))}
            <a
              href="#offer"
              onClick={(e) => scrollToSection(e, '#offer')}
              className="block mt-4 text-center bg-[#C9A462] text-[#0E1114] font-bold text-[15px] px-6 py-4 no-underline"
            >
              {sl ? 'Brezplačen posvet' : 'Free consultation'}
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default NewHeader;
